// extracted by mini-css-extract-plugin
module.exports = {"button":"LogoutButton_button__hte1s","loadingSpinner":"LogoutButton_loadingSpinner__5C_8f"};